import * as vp from 'vopay';
import * as Yup from 'yup';
import { FunctionComponent } from 'react';
import { Formik } from 'formik';
import styles from '../../Login.module.scss';
import { useTranslation } from 'react-i18next';

const { TextField, Button, Box, Title, Checkbox } = vp;
export type PinFormFeilds = {
  Code: string;
  rememberDevice: boolean;
};
type TwoFactorAuthenticationPinProps = {
  handleCancel: () => void;
  handleFormSubmit: (value: PinFormFeilds) => void;
  initialValues: PinFormFeilds;
  hasError: boolean;
  errorMsg: string;
};

type FC = FunctionComponent<TwoFactorAuthenticationPinProps>;

const TwoFactorAuthenticationPin: FC = (props: TwoFactorAuthenticationPinProps) => {
  const { handleCancel, handleFormSubmit, initialValues, hasError, errorMsg } = props;
  const { t } = useTranslation('translations', { keyPrefix: 'Login.MFA.Code' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global.Buttons' });

  return (
    <>
      <Box flx="col" width="100%">
        <Box mb="sm" flx="col" ai="center" height="auto">
          <Title title={t('title')} bold size="xsm" />
        </Box>
        <Formik
          initialValues={initialValues}
          validationSchema={twoFactorAuthenticationPinValidationSchema()}
          onSubmit={handleFormSubmit}
        >
          {({ values, handleChange, handleBlur, handleSubmit, errors, touched, isSubmitting }) => (
            <form onSubmit={handleSubmit}>
              <Box mb="sm" flx="col" height="auto">
                <TextField
                  key="Code"
                  name="Code"
                  placeholder={t('inputPlaceholder')}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.Code}
                  variant="border"
                  height="50px"
                  error={errors.Code && touched.Code ? errors.Code : null}
                />
              </Box>
              <Box flx="row" pb="sm" height="auto">
                <Checkbox
                  key="rememberDevice"
                  name="rememberDevice"
                  variant="border"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.rememberDevice}
                  hasNoPadding
                />
                <Box ps="sm">{t('checkboxLabel')}</Box>
              </Box>
              {hasError && (
                <div className={styles.errorMSG} style={{ paddingBottom: 15, paddingTop: 0 }}>
                  {errorMsg}
                </div>
              )}
              <Box jc="fe" flx="col" height="auto">
                <Button
                  id="submit-pin"
                  label={tGlobal('submit')}
                  type="submit"
                  size="xlg"
                  textSize={1}
                  isDisabled={isSubmitting}
                />
              </Box>
            </form>
          )}
        </Formik>
        <Box mt="sm" height="auto" jc="center" ai="center">
          <Button
            id="forgot-password-cancel"
            type="button"
            label={tGlobal('cancel')}
            color="none"
            noShadow
            noPadding
            bold
            textSize={1}
            onClick={() => {
              handleCancel();
            }}
          />
        </Box>
      </Box>
    </>
  );

  function twoFactorAuthenticationPinValidationSchema() {
    return Yup.object().shape({
      Code: Yup.string().label(t('codeLabel')).required(),
    });
  }
};

export default TwoFactorAuthenticationPin;
